import React from 'react';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import '../App.css';

import {
  SiReact, SiFlutter, SiSpringboot, SiPython, SiNodedotjs,
  SiMongodb, SiDocker, SiGooglecalendar, SiGmail,
  SiHtml5, SiCss3, SiJavascript, SiDotnet,
  SiFirebase, SiAnaconda, SiFigma, SiSqlite 
} from 'react-icons/si';

import { FaWindows, FaRobot, FaCode, FaMicrochip, FaServer } from 'react-icons/fa';

const techMap = {
  'React Native': { icon: SiReact, color: '#61DAFB' },
  'React': { icon: SiReact, color: '#61DAFB' },
  'Flutter': { icon: SiFlutter, color: '#02569B' },
  'HTML': { icon: SiHtml5, color: '#E34F26' },
  'CSS': { icon: SiCss3, color: '#1572B6' },
  'JavaScript': { icon: SiJavascript, color: '#F7DF1E' }, 
  'Spring Boot': { icon: SiSpringboot, color: '#6DB33F' },
  'Node.js': { icon: SiNodedotjs, color: '#339933' },
  'Python Flask': { icon: SiPython, color: '#306998' },
  'Python': { icon: SiPython, color: '#306998' },
  'MongoDB': { icon: SiMongodb, color: '#47A248' },
  'Firebase Firestore': { icon: SiFirebase, color: '#FFCA28'  },
  'Firebase Auth': { icon: SiFirebase, color: '#FFA000'},
  'Figma': { icon: SiFigma, color: '#F24E1E' },
  'SQLite': { icon: SiSqlite, color: '#003B57' },
  'RESTful API': { icon: FaServer, color: '#7c5cfc' },
  'C#': { icon: SiDotnet, color: '#512BD4' }, 
  '.NET': { icon: SiDotnet, color: '#512BD4' },
  'Windows Forms': { icon: FaWindows, color: '#0078D4' },
  'WPF': { icon: FaWindows, color: '#0078D4' },
  'LSTM': { icon: SiAnaconda, color: '#44A833' },
  'NLP': { icon: FaMicrochip, color: '#FF7043' },
  'n8n': { icon: FaRobot, color: '#EA4B71' },
  'Docker': { icon: SiDocker, color: '#2496ED' },
  'Multi-threading': { icon: FaCode, color: '#A0A0A0' },
  'Google Calendar API': { icon: SiGooglecalendar, color: '#4285F4' },
  'Gmail API': { icon: SiGmail, color: '#D93025' },
  'Google Scholar API': { icon: SiGooglecalendar, color: '#4285F4' },
};

const TechIcon = ({ techName }) => {
  const cleanName = techName.trim();
  const techData = techMap[cleanName] || techMap[cleanName.split(' ')[0]];
  
  if (!techData) {
    return <span className="tech-tag">{cleanName}</span>;
  }
  
  const IconComponent = techData.icon;
  return (
    <span className="tech-tag">
      <IconComponent className="tech-icon-svg" style={{ color: techData.color }} />
      {cleanName}
    </span>
  );
};

const Projects = ({ t, allProjects }) => {
  return (
    <section id="projects" className="section-spacing">
      <motion.h2 
        className="section-heading"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
      >
        {t.projectsTitle}
      </motion.h2>

      <div className="bento-grid projects-grid">
        {allProjects.map((project, index) => {
          return (
            <motion.div
              key={index}
              className="bento-card bento-item project-card glass-panel"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.4, 0, 0.2, 1] }}
              whileHover={{ scale: 1.02, y: -4, transition: { duration: 0.3 } }}
            >
              <div className="project-top">
                <div className="project-icon-box">
                  {project.isLogo ? (
                    <img src={project.imageLottie} alt={project.name} className="project-img-logo"/>
                  ) : (
                    <Lottie animationData={project.imageLottie} loop={true} className="project-lottie" />
                  )}
                </div>
                <div className="project-titles">
                  <h3 className="project-title">{project.name}</h3>
                  {project.link && (
                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link-badge">Makaleyi İncele ↗</a>
                  )}
                </div>
              </div>
              
              <p className="project-desc">{project.desc}</p>
              
              <div className="project-tags">
                {project.lang && project.lang.split(',').map((tech, i) => (
                  <TechIcon key={i} techName={tech} />
                ))}
              </div>
            </motion.div>
          )
        })}
      </div>
    </section>
  );
};

export default Projects;
